<template>
  <div></div>
</template>
<script>
import Auth from '../services/auth'

export default {
  name: 'Logout',
  created: function () {
    this.$user = {}

    Auth.logout().then(() => {
      this.$eventBus.$emit('updateUser', null)
      window.location.href = '/'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Logout.vue